import { client } from './client'
import { getCsrf, getCookie } from './authentication'
import { CustomError } from '../CustomError'
import { CSRF_TOKEN_NAME } from '@/constants'

/**
 * List all projects in a user's account
 */
export const listProjects = async ({
  search,
  limit,
  offset,
  userId = [],
}: {
  search?: string
  limit?: number
  offset?: number
  userId?: Array<number>
}) => {
  const resp = await client.GET('/api/v1/projects/projects', {
    params: {
      query: {
        search,
        limit,
        offset,
        user_id: userId,
      },
    },
  })

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to list projects'
    throw new CustomError(resp, message)
  }

  return {
    projects: resp.data.items,
    totalProjects: resp.data.count,
    limit,
    offset,
  }
}

/**
 * Get a project
 * @param projectId
 * @returns
 */
export const getProject = async (projectId: string) => {
  const resp = await client.GET('/api/v1/projects/projects/{project_id}', {
    params: {
      path: {
        project_id: projectId,
      },
    },
  })

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to get project'
    throw new CustomError(resp, message)
  }

  return resp.data
}

/**
 * Create a new project
 * @param values
 * @returns
 */
export const createProject = async (values: { name: string }) => {
  await getCsrf()
  const resp = await client.POST('/api/v1/projects/projects', {
    headers: {
      'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
    },
    body: values,
  })

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to create project'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const updateProject = async (
  projectId: string,
  values: { name: string },
) => {
  await getCsrf()
  const resp = await client.PUT('/api/v1/projects/projects/{project_id}', {
    params: {
      path: {
        project_id: projectId,
      },
    },
    headers: {
      'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
    },
    body: values,
  })

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to update project'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const deleteProject = async (projectId: string) => {
  await getCsrf()
  const resp = await client.DELETE('/api/v1/projects/projects/{project_id}', {
    params: {
      path: {
        project_id: projectId,
      },
    },
    headers: {
      'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
    },
    parseAs: 'text',
  })

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to delete project'
    throw new CustomError(resp, message)
  }

  return true
}
